import type { SearchSearchCriteriaSchema } from '@iconik-io/iconik-api/src/services/search';

export const getSearchDocument = (
  assetsIds: string[],
  objectTypes?: SearchSearchCriteriaSchema['doc_types'],
  includeFields?: string[],
): SearchSearchCriteriaSchema => ({
  doc_types: objectTypes ?? ['assets'],
  filter: {
    operator: 'OR',
    terms: [{ name: 'id', value_in: assetsIds }],
  },
  include_fields: includeFields,
});
